@if (images.length === 3) {
	<div class="masonry-gap grid w-full grid-cols-2 sm:grid-cols-3">
		<div class="relative col-span-2 h-auto bg-accent-50 sm:row-span-2">
			<vp-image
				[image]="{
					src: images[0].src,
					width: 639,
					height: 472,
				}"
				[sources]="[
					{ min: null, max: sizes.sm, width: 639, height: 472 },
					{
						min: sizes.sm,
						max: sizes.md,
						width: 502,
						height: 320,
					},
					{
						min: sizes.md,
						max: sizes.lg,
						width: 670,
						height: 400,
					},
					{
						min: sizes.lg,
						max: null,
						width: 825,
						height: 480,
					},
				]"
				className="size-full"
			/>
		</div>
		@for (image of images | slice: 1; track $index) {
			<div class="h-auto bg-accent-50">
				<vp-image
					[image]="{
						src: image.src,
						width: 242,
						height: 242,
					}"
					[sources]="[
						{
							min: null,
							max: sizes.sm,
							width: 310,
							height: 310,
						},
						{
							min: sizes.sm,
							max: sizes.md,
							width: 239,
							height: 188,
						},
						{
							min: sizes.md,
							max: sizes.lg,
							width: 320,
							height: 224,
						},
						{
							min: sizes.lg,
							max: null,
							width: 395,
							height: 264,
						},
					]"
					className="size-full"
				/>
			</div>
		}
	</div>
}
@if (images.length === 4) {
	<div class="masonry-gap grid w-full grid-cols-3 sm:grid-cols-3">
		<div class="col-span-3 h-auto bg-accent-50 sm:col-span-1 sm:row-span-2">
			<vp-image
				[image]="{
					src: images[0].src,
					width: 639,
					height: 472,
				}"
				[sources]="[
					{ min: null, max: sizes.sm, width: 639, height: 472 },
					{
						min: sizes.sm,
						max: sizes.md,
						width: 239,
						height: 400,
					},
					{
						min: sizes.md,
						max: sizes.lg,
						width: 320,
						height: 480,
					},
					{
						min: sizes.lg,
						max: null,
						width: 395,
						height: 560,
					},
				]"
				className="size-full"
			/>
		</div>
		<div class="h-auto bg-accent-50 sm:col-span-1 sm:row-span-2">
			<vp-image
				[image]="{
					src: images[1].src,
					width: 242,
					height: 242,
				}"
				[sources]="[
					{ min: null, max: sizes.sm, width: 242, height: 242 },
					{
						min: sizes.sm,
						max: sizes.md,
						width: 239,
						height: 400,
					},
					{
						min: sizes.md,
						max: sizes.lg,
						width: 320,
						height: 480,
					},
					{
						min: sizes.lg,
						max: null,
						width: 395,
						height: 560,
					},
				]"
				className="size-full"
			/>
		</div>
		@for (image of images | slice: 2; track $index) {
			<div class="h-auto bg-accent-50">
				<vp-image
					[image]="{
						src: image.src,
						width: 639,
						height: 304,
					}"
					[sources]="[
						{
							min: null,
							max: sizes.sm,
							width: 639,
							height: 304,
						},
						{
							min: sizes.sm,
							max: sizes.md,
							width: 240,
							height: 188,
						},
						{
							min: sizes.md,
							max: sizes.lg,
							width: 320,
							height: 224,
						},
						{
							min: sizes.lg,
							max: null,
							width: 396,
							height: 264,
						},
					]"
					className="size-full"
				/>
			</div>
		}
	</div>
}
@if (images.length === 5) {
	<div class="masonry-gap grid w-full grid-cols-3 sm:grid-cols-6">
		@for (image of images | slice: 0 : 2; track $index) {
			<div class="col-span-3 h-auto bg-accent-50 sm:col-span-3">
				<vp-image
					[image]="{
						src: image.src,
						width: 639,
						height: 242,
					}"
					[sources]="[
						{
							min: null,
							max: sizes.sm,
							width: 639,
							height: 242,
						},
						{
							min: sizes.sm,
							max: sizes.md,
							width: 372,
							height: 340,
						},
						{
							min: sizes.md,
							max: null,
							width: 608,
							height: 320,
						},
					]"
					className="size-full"
				/>
			</div>
		}
		@for (image of images | slice: 2; track $index) {
			<div class="h-auto bg-accent-50 sm:col-span-2">
				<vp-image
					[image]="{
						src: image.src,
						width: 242,
						height: 242,
					}"
					[sources]="[
						{
							min: null,
							max: sizes.sm,
							width: 242,
							height: 242,
						},
						{
							min: sizes.sm,
							max: sizes.md,
							width: 360,
							height: 204,
						},
						{
							min: sizes.md,
							max: null,
							width: 395,
							height: 208,
						},
					]"
					className="size-full"
				/>
			</div>
		}
	</div>
}
